import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Carousel from 'react-multi-carousel';
import { Button, Col, Container, Row } from 'reactstrap';
import { getBlogs } from '../redux/actions/blogs.action';
import {
	ArticleImg,
	OurPartner1,
	OurPartner2,
	OurPartner3,
	OurPartner4,
	AboutusIdea,
	AboutusBanner,
} from '../assets';
import moment from 'moment';
import { Link } from 'react-router-dom';

const About = props => {
	const { blogs } = useSelector(state => state.blogs);
	const dispatch = useDispatch();
	useEffect(() => {
		if (blogs.length == 0) {
			dispatch(getBlogs());
		}
	}, []);
	const responsive = {
		desktop: {
			breakpoint: { max: 3000, min: 1024 },
			items: 4,
			slidesToSlide: 3, // optional, default to 1.
		},
		tablet: {
			breakpoint: { max: 1024, min: 464 },
			items: 2,
			slidesToSlide: 2, // optional, default to 1.
		},
		mobile: {
			breakpoint: { max: 464, min: 0 },
			items: 1,
			slidesToSlide: 1, // optional, default to 1.
		},
	};
	return (
		<>
			<div id='our-partners' className='mb-5'>
				<Container>
					<small className='text-dark font-weight-semibold'>
						Main / About us
					</small>
					<h1
						className='text-uppercase section-title '
						style={{
							fontFamily: 'Ogg',
							letterSpacing: 4,
							wordSpacing: 8,
						}}
					>
						About Memora
					</h1>
				</Container>
				<div
					className='about-us-banner'
					style={{ backgroundImage: `url('${AboutusBanner}')` }}
				></div>
				<Container>
					<h5 className='my-3'>
						While walking through a cemetery with his parent, one of
						our co-founders stopped to think.{' '}
						<i className='h1' style={{ color: '#C7C7C7' }}>
							Who are all these people? What was their story? What
							if graves could talk?
						</i>{' '}
						He wondered, and thus the idea of Memora was conceived.{' '}
					</h5>
					<Row className='my-5 align-items-center'>
						<Col md='8' lg='7' xl='6'>
							<img src={AboutusIdea} className='w-100' />
						</Col>
						<Col md='4' lg='5' xl='6'>
							<h5>
								Memora is on a mission to keep memories alive
								for future generations, thereby ensuring that
								they have a reliable way to remember and honor
								those who came before them. The platform serves
								as a digital front door through which the flame
								of a life can be kept alight and memories etched
								in stone.
								<br />
								With Memora and our unique QR codes, you can
								transform your loved one’s resting place to a
								monument that bears witness of a life
								well-lived.
							</h5>
							<h5 className='mt-5'>
								Memora gives you a space to collaborate and
								share memories in a way that ensures that they
								live on forever.{' '}
							</h5>
						</Col>
					</Row>
					<h1
						className='text-uppercase section-title py-5'
						style={{
							fontFamily: 'Ogg',
							letterSpacing: 4,
							wordSpacing: 8,
						}}
					>
						Our partners
					</h1>
					<Carousel
						responsive={responsive}
						showDots={true}
						removeArrowOnDeviceType={[
							'desktop',
							'tablet',
							'mobile',
						]}
						infinite={true}
						autoPlay={true}
						autoPlaySpeed={3000}
					>
						<div
							className='d-flex p-4 align-items-center justify-content-center h-100'
							style={{ maxWidht: '95%' }}
						>
							<img src={OurPartner1} className='w-100' />
						</div>
						<div
							className='d-flex p-4 align-items-center justify-content-center h-100'
							style={{ maxWidht: '95%' }}
						>
							<img src={OurPartner2} className='w-100' />
						</div>
						<div
							className='d-flex p-4 align-items-center justify-content-center h-100'
							style={{ maxWidht: '95%' }}
						>
							<img src={OurPartner3} className='w-100' />
						</div>
						<div
							className='d-flex p-4 align-items-center justify-content-center h-100'
							style={{ maxWidht: '95%' }}
						>
							<img src={OurPartner4} className='w-100' />
						</div>
						<div
							className='d-flex p-4 align-items-center justify-content-center h-100'
							style={{ maxWidht: '95%' }}
						>
							<img src={OurPartner1} className='w-100' />
						</div>
						<div
							className='d-flex p-4 align-items-center justify-content-center h-100'
							style={{ maxWidht: '95%' }}
						>
							<img src={OurPartner2} className='w-100' />
						</div>
						<div
							className='d-flex p-4 align-items-center justify-content-center h-100'
							style={{ maxWidht: '95%' }}
						>
							<img src={OurPartner3} className='w-100' />
						</div>
						<div
							className='d-flex p-4 align-items-center justify-content-center h-100'
							style={{ maxWidht: '95%' }}
						>
							<img src={OurPartner4} className='w-100' />
						</div>
					</Carousel>
					<div
						id='articles-you-may-be-interested-in'
						className='mt-5 pt-5 section-start'
					>
						<Container>
							<h1
								className='text-uppercase section-title pb-5'
								style={{
									fontFamily: 'Ogg',
									letterSpacing: 4,
									wordSpacing: 8,
								}}
							>
								our blog
							</h1>
							<Row className='mt-4'>
								{blogs.length > 0 &&
									blogs.slice(0, 4).map((blog, idx) => (
										<Link to={`/main/blog/${blog.id}`}>
											<Col
												md='6'
												lg='4'
												xl='3'
												className='text-left mb-5'
											>
												<img
													src={
														blog.cover_images
															.length > 0 &&
														blog.cover_images[0]
													}
													className='w-100 mb-4'
												/>
												<small className='text-muted'>
													{moment
														.unix(
															blog.created_at
																.seconds
														)
														.format('DD MMMM YYYY')}
												</small>
												<h5
													className='text-uppercase'
													style={{
														fontFamily: 'Ogg',
														letterSpacing: 6,
													}}
												>
													{blog.title}
												</h5>
												<p className='mt-4'>
													<div
														dangerouslySetInnerHTML={{
															__html:
																blog.desc
																	.length >
																100
																	? blog.desc.substr(
																			0,
																			100
																	  ) +
																	  '......'
																	: blog.desc,
														}}
													></div>
												</p>
											</Col>
										</Link>
									))}
							</Row>
							<div className='d-flex justify-content-center mt-4'>
								<Link to='/main/blog'>
									<Button className='btn-outline landing-btn'>
										More Articles
									</Button>
								</Link>
							</div>
						</Container>
					</div>
				</Container>
			</div>
		</>
	);
};

export default About;
